<template>
  <div>
    <el-dialog title="生成兑换码" center :visible="true" @close="onClose" :close-on-click-modal="false"
      :close-on-press-escape="false" width="700px">
      <el-form ref="form" :model="form" label-width="240px" size="mini">
        <el-form-item label="礼包：">
          <span>{{ this.form.giftName }}</span>
        </el-form-item>
        <el-form-item label="自定义兑换码：">
          <el-switch v-model="form.isNotUseSuffix" active-color="#13ce66" @change="changeSwitch">
          </el-switch>
        </el-form-item>
        <el-form-item v-if="form.isNotUseSuffix" label="兑换码：" prop="prefix">
          <el-input v-model="form.code" style="width: 150px"></el-input><span style="color: red">（建议长度不超过9位）</span>
        </el-form-item>
        <el-form-item v-if="!form.isNotUseSuffix" label="生成几个批次的随机兑换码：">
          <el-input v-model="form.cycleCount" style="width: 100px"></el-input><span
            style="color: red">（需不小于1、不大于100）</span>
        </el-form-item>
        <el-form-item v-if="!form.isNotUseSuffix" label="每批次随机兑换码的数量：" prop="count">
          <el-input v-model="form.count" style="width: 100px"></el-input><span
            style="color: red">（需不小于1、不大于10000）</span>
        </el-form-item>
        <el-form-item label="单个兑换码可被使用次数：" prop="useCount">
          <el-input :disabled="!form.isNotUseSuffix" v-model="form.useCount" style="width: 100px"></el-input><span
            v-if="form.isNotUseSuffix" style="color: red">（0表示不限次数）</span>
        </el-form-item>
        <el-form-item label="本批次仅可被同一玩家使用一次：" prop="name">
          <el-switch v-model="isOnlyRedeemOneTimes" :disabled="form.isNotUseSuffix" active-color="#13ce66"
            @change="changeSwitch2">
          </el-switch>
        </el-form-item>
        <el-form-item label="适用渠道：">
          <channel-selector placeholder="请选择" enableFullChannels @ready="onChannelSelectorReady"
            @change="onChannelSelectorChange" ref="channelSelector">
          </channel-selector>
        </el-form-item>
        <el-form-item label="设置有效期：">
          <el-switch v-model="form.settingAt" active-color="#13ce66">
          </el-switch>
        </el-form-item>
        <el-form-item label="生效日期：" v-if="form.settingAt">
          <el-date-picker v-model="form.startAt" type="date" :clearable="false" placeholder="选择日期" format="yyyy-MM-dd"
            value-format="timestamp">
          </el-date-picker><span style="color: red">（当天零点生效）</span>
        </el-form-item>
        <el-form-item label="失效日期：" v-if="form.settingAt">
          <el-date-picker v-model="form.endAt" type="date" :clearable="false" placeholder="选择日期" format="yyyy-MM-dd"
            value-format="timestamp" :picker-options="pickerEndAtOptions">
          </el-date-picker><span style="color: red">（当天零点失效）</span>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="form.remark" style="width: 220px" type="textarea" rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()">生成</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const luxon = require("luxon");
import ChannelSelector from "@/components/ChannelSelector";

// 本弹窗名称
const DialogName = "AddRedeemCodeDialog";

export default {
  data() {
    return {
      form: {
        giftName: "",
        code: "",
        settingAt: false,
        prefix: "",
        giftId: "",
        remark: "",
        cycleCount: 1, // 生成几个批次的随机兑换码
        count: 1, // 每批次随机兑换码的数量
        useCount: 1,
        startAt: luxon.DateTime.now().startOf("day").toMillis(),
        endAt: luxon.DateTime.now().startOf("day").toMillis(),
        channelId: 0,
        isNotUseSuffix: false,
      },
      isOnlyRedeemOneTimes: false,
      parentEntry: null,
    };
  },
  components: {
    ChannelSelector,
  },

  async created() {
    let value = this.$dialogutil.getData(DialogName);

    this.form.giftId = value.entry.id;
    this.form.giftName = value.entry.name;

    this.parentEntry = value.entry;
  },

  computed: {
    pickerEndAtOptions() {
      let that = this;
      return {
        disabledDate(time) {
          return time.getTime() < that.form.startAt;
        },
        shortcuts: [
          {
            text: "生效后一天",
            onClick(picker) {
              const date = new Date(that.form.startAt);
              date.setTime(date.setDate(date.getDate() + 1));
              picker.$emit("pick", date);
            },
          },
          {
            text: "生效后三天",
            onClick(picker) {
              const date = new Date(that.form.startAt);
              date.setTime(date.setDate(date.getDate() + 3));
              picker.$emit("pick", date);
            },
          },
          {
            text: "生效后七天",
            onClick(picker) {
              const date = new Date(that.form.startAt);
              date.setTime(date.setDate(date.getDate() + 7));
              picker.$emit("pick", date);
            },
          },
          {
            text: "生效后三十天",
            onClick(picker) {
              const date = new Date(that.form.startAt);
              date.setTime(date.setDate(date.getDate() + 30));
              picker.$emit("pick", date);
            },
          },
          {
            text: "生效后一年",
            onClick(picker) {
              const date = new Date(that.form.startAt);
              date.setTime(
                date.setFullYear(
                  date.getFullYear() + 1,
                  date.getMonth(),
                  date.getDate()
                )
              );
              picker.$emit("pick", date);
            },
          },
        ],
      };
    },
  },

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = this.form.channelId;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
    },

    async changeSwitch(e) {
      this.form.code = "";
      if (e) {
        this.form.useCount = 0;
        this.isOnlyRedeemOneTimes = true;
      } else {
        this.form.useCount = 1;
      }
    },
    async changeSwitch2(e) {
      if (e) {
        this.isOnlyRedeemOneTimes = true;
        this.form.availableRedeemTimes = 1;
      } else {
        this.isOnlyRedeemOneTimes = false;
        this.form.availableRedeemTimes = 0;
      }
    },
    /**
     * 提交表单
     */
    submit() {
      this.add();
    },

    /**
     * 新增
     */
    async add() {
      let cycleCount = Number(this.form.cycleCount);
      if (
        isNaN(cycleCount) ||
        cycleCount != parseInt(this.form.cycleCount) ||
        cycleCount < 1 ||
        cycleCount > 100
      ) {
        this.$message.error("请检查输入");
        return;
      }

      let count = Number(this.form.count);
      if (
        isNaN(count) ||
        count != parseInt(this.form.count) ||
        count < 1 ||
        count > 10000
      ) {
        this.$message.error("请检查输入");
        return;
      }

      let useCount = Number(this.form.useCount);
      if (
        isNaN(useCount) ||
        useCount != parseInt(this.form.useCount) ||
        useCount < 0
      ) {
        this.$message.error("请检查输入");
        return;
      }

      try {
        // 弹确认框
        await this.$confirm(`确认生成兑换码？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/generateRedeemCode`,
            this.form,
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "生成成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose();

        let entry = this.parentEntry;
        entry.currentCycleId = resData.data.cycleId;

        // 弹确认框
        await this.$confirm(`生成成功`, {
          showCancelButton: false,
          confirmButtonText: "查看",
        }).then(() => {
          this.$dialogutil.open("RedeemCodeGiftDetailsDialog", {
            closedCallback: null,
            data: { entry },
          });
        });
      } catch (e) { }
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>